module.exports = __webpack_public_path__ + "static/media/libratone-track-air-plus.0ea3c364.png";